'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _notAfter = require('./not-after');
var _notAfter2 = _interopRequireDefault(_notAfter);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (days, errorMessage, extraOptions) {
  var today = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Date();
  var test = new Date(today.getFullYear(), today.getMonth(), today.getDate() + days // we must count today as day 1
  );
  return (0, _notAfter2.default)(test, errorMessage, Object.assign({}, extraOptions, {
    days: days
  }));
};